import { Dialog } from "primereact/dialog";
import React, { useEffect, useMemo, useState } from "react";
import { Button as PrimereactButton } from "primereact/button";
import {
  Button,
  Modal,
  MultiSelect,
  Select,
  Textarea,
  Textfield,
} from "../../../../../../components/core";
import { useDispatch } from "react-redux";
import { handleEditChange } from "../../../../../../features/partner-types/partner-types-table-slice";
import { useMutation } from "@apollo/client";
import { UPDATE_PARTNER_TYPE } from "../../../../../../constants/graphql/partner-types-query";
import { Strings } from "../../../../../../constants/strings";
import useSidebarStore from "../../../../../../zustand/stores/sidebar-store";
import { useNavigate } from "react-router-dom";

const EditPartnerTypeDialog = ({
  openEditDialog,
  setOpenEditDialog,
  index = 0,
  cancelEditPartnerType,
  // openCancelModal,
  // setOpenCancelModal,
  setChangesMade,
  selectedData,
  setSelectedData,
  changesMade,
}) => {
  // utils
  const navigate = useNavigate();
  // LS
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;

  // redux
  const dispatch = useDispatch();
  const partnerCategoryList = [
    { value: 0, name: "Courier" },
    { value: 1, name: "Seller" },
  ];

  const lockerTypes = [
    { value: 1, label: "Parcel" },
    { value: 2, label: "Fridge" },
  ];
  // gql
  const [editPartnerTypeMutation] = useMutation(UPDATE_PARTNER_TYPE);

  // local variables
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  // validation dialog
  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
    actions: "",
  });

  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

  useEffect(() => {
    if (pendingNavigation !== null) {
      if (changesMade) {
        setOpenCancelModal(true);
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);

  // Convert partner locker type access to objects for MultiSelect
  const selectedLockerTypes = useMemo(() => {
    if (!selectedData?.partnerLockerTypeAccess) return [];

    return selectedData.partnerLockerTypeAccess.map(({ lockerType }) => {
      // Find the matching object from lockerTypes array or create a default object
      return (
        lockerTypes.find(
          (type) => type.value === parseInt(lockerType.lockerTypeId)
        ) || {
          value: parseInt(lockerType.lockerTypeId),
          label: lockerType.lockerType,
        }
      );
    });
  }, [selectedData, lockerTypes]);

  // Handle multiselect change specifically
  // Handle multiselect change specifically
  const handleLockerTypeChange = (e) => {
    setChangesMade(true);

    // Get the selected values array from e.target.value
    const selectedValues = e.target?.value || [];

    // Create new partnerLockerTypeAccess array from the selected values
    const newPartnerLockerTypeAccess = selectedValues.map((item) => ({
      __typename: "PartnerLockerTypeAccess",
      lockerType: {
        __typename: "LockerType",
        lockerTypeId: item.value.toString(),
        lockerType: item.label,
      },
    }));

    // Update selectedData with new partnerLockerTypeAccess array
    setSelectedData({
      ...selectedData,
      partnerLockerTypeAccess: newPartnerLockerTypeAccess,
      partnerLockerTypeAccessString: selectedValues
        .map((item) => item.label)
        .join(", "),
    });

    // Also dispatch to the reducer
    dispatch(
      handleEditChange({
        target: {
          name: "lockerTypes",
          value: selectedValues, // Pass the full array of selected items
          id: selectedData.partnerTypeId,
        },
      })
    );
  };

  // Handle input changes for other fields
  const handleInputChange = (e, id) => {
    const { name, value } = e.target;

    setChangesMade(true);
    dispatch(
      handleEditChange({
        target: {
          name,
          value,
          id,
        },
      })
    );
    setSelectedData({
      ...selectedData,
      [e.target.name]: e.target.value,
    });
  };

  const validateFields = () => {
    // Check if selectedData exists and has entries at the specified index
    if (!selectedData) {
      console.error("No data at specified index to validate");
      return false;
    }

    console.log({ INSIDE_VALIDATE: selectedData });

    // Define required fields
    const requiredFields = {
      partnerType: "Partner Type",
      partnerCategoryNo: "Partner Category",
      monthlyFee: "Monthly Fee",
      description: "Description",
    };

    // Check for lockerTypes specifically since it's an array
    if (
      !selectedData.partnerLockerTypeAccess ||
      selectedData.partnerLockerTypeAccess.length === 0
    ) {
      showValidationError(
        "Locker Types",
        "At least one locker type must be selected."
      );
      return false;
    }

    // Check all other required fields
    for (const [field, label] of Object.entries(requiredFields)) {
      if (!selectedData[field] && selectedData[field] !== 0) {
        showValidationError(label, `${label} is required.`);
        return false;
      }
    }

    // Additional validation for specific fields
    if (selectedData.monthlyFee && isNaN(parseFloat(selectedData.monthlyFee))) {
      showValidationError("Monthly Fee", "Monthly Fee must be a valid number.");
      return false;
    }

    // All validations passed
    setSaveDialogOpen(true);

    // Helper function to show the validation error modal
    function showValidationError(fieldName, message) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: `Missing ${fieldName}`,
        message: message,
        open: true,
        actions: (
          <div className="grid grid-cols-1 gap-2">
            <Button
              onClick={() => {
                setValidation((prev) => ({
                  ...prev,
                  open: false,
                }));
              }}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    }
  };

  const editPartnerype = () => {
    console.log({ selectedData });
    editPartnerTypeMutation({
      variables: {
        courierTypes: [
          {
            partnerTypeId: selectedData.partnerTypeId,
            partnerType: selectedData.partnerType,
            partnerCategoryNo: parseInt(selectedData.partnerCategoryNo),
            lockerTypes: selectedData.partnerLockerTypeAccess.map(
              (item) => item.lockerType.lockerTypeId
            ),
            description: selectedData.description,
            monthlyFee: parseFloat(selectedData.monthlyFee),
            operatorId: operatorId,
          },
        ],
      },
    })
      .then((data) => {
        if (data) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: Strings.popup_success_title_default,
            message: Strings.popup_success_message_edit,
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  onClick={() => {
                    setValidation((prev) => ({
                      ...prev,
                      open: false,
                    }));

                    setOpenEditDialog(false);
                    setSaveDialogOpen(false);
                    window.location.reload();
                  }}
                  value={"OK"}
                  className={"p-2"}
                />
              </div>
            ),
          });
        }
      })
      .catch((e) => {
        if (e.message.includes(`duplicate key value`)) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title_duplicate,
            message: "Partner Type already exists",
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  onClick={() => {
                    setValidation((prev) => ({
                      ...prev,
                      open: false,
                    }));
                    setSaveDialogOpen(false);
                  }}
                  value={"OK"}
                  className={"p-2"}
                />
              </div>
            ),
          });
        } else {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title,
            message: Strings.popup_error_message_add,
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  onClick={() => {
                    setValidation((prev) => ({
                      ...prev,
                      open: false,
                    }));
                  }}
                  value={"OK"}
                  className={"p-2"}
                />
              </div>
            ),
          });
        }
      });
  };
  return (
    <>
      <Dialog
        visible={openEditDialog}
        onHide={() => {
          setOpenEditDialog(false);
        }}
        header="Edit Partner Type"
        className="w-[480px]"
        draggable={false}
        resizable={false}
        footer={
          <div className="flex w-full items-center justify-center gap-2">
            <PrimereactButton
              className="border border-primary-primaryYellow bg-white text-black p-2 gap-2 font-normal"
              onClick={() => {
                setOpenCancelModal(true);
              }}
            >
              Cancel
            </PrimereactButton>
            <PrimereactButton
              className="bg-primary-primaryYellow p-2 gap-2 text-black font-semibold"
              onClick={() => validateFields()}
              disabled={!changesMade}
            >
              Save Changes
            </PrimereactButton>
          </div>
        }
      >
        <div className="flex gap-3 flex-col">
          <div className="flex gap-2 flex-col">
            <div>
              <span className="text-red-500">* </span>Partner Type:
            </div>
            <Textfield
              onChange={(e) => handleInputChange(e, selectedData.partnerType)}
              name="partnerType"
              value={selectedData.partnerType}
            />
          </div>

          <div className="flex gap-2 flex-col">
            <div>
              <span className="text-red-500">* </span>Partner Category:
            </div>
            <Select
              disabled
              items={partnerCategoryList}
              name="partnerCategoryNo"
              value={selectedData?.partnerCategoryNo}
            />
          </div>

          <div className="flex gap-2 flex-col">
            <div>
              <span className="text-red-500">* </span>Has Access To:
            </div>
            <MultiSelect
              items={lockerTypes}
              name="lockerTypes"
              onChange={handleLockerTypeChange}
              value={selectedLockerTypes}
            />
          </div>

          <div className="flex gap-2 flex-col">
            <div>
              <span className="text-red-500">* </span>Monthly Fee:
            </div>
            <Textfield
              onChange={handleInputChange}
              name="monthlyFee"
              isNumberOnly={true}
              value={selectedData?.monthlyFee}
            />
          </div>

          <div className="flex gap-2 flex-col">
            <div>
              <span className="text-red-500">* </span>Description:
            </div>
            <Textarea
              onChange={handleInputChange}
              name="description"
              value={selectedData?.description}
            />
          </div>
        </div>
      </Dialog>

      <Modal
        icon={`${process.env.PUBLIC_URL}/assets/images/check.png`}
        title="Save Changes"
        message="Are you sure you want to save all changes?"
        open={saveDialogOpen}
        actions={
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => setSaveDialogOpen(false)}
              value={"No"}
              className={"p-2"}
            />
            <Button
              onClick={() => {
                editPartnerype();
              }}
              value={"Yes"}
              className={"p-2"}
            />
          </div>
        }
      />

      <Modal
        icon={`${process.env.PUBLIC_URL}/assets/images/error.png`}
        title="Cancel Changes"
        message="Are you sure you want to cancel all changes?"
        open={openCancelModal}
        actions={
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => {
                setOpenCancelModal(false);
                setActiveSubItem(activeSubItem);
                setPendingNavigation(null);
              }}
              value={"No"}
              className={"p-2"}
            />
            <Button
              onClick={() => {
                // console.log("CLICK CLICK CLICK");
                setOpenEditDialog(false);
                setOpenCancelModal(false);
                setChangesMade(false);
                cancelEditPartnerType();
              }}
              value={"Yes"}
              className={"p-2"}
            />
          </div>
        }
      />

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </>
  );
};

export default EditPartnerTypeDialog;
